<template>
  <el-dialog
    title="添加备注"
    :visible.sync="dialogVisible"
    width="500px"
    :before-close="handleClose"
    @close="handleClose"
  >
    <el-form
      ref="noteForm"
      :model="form"
      :rules="rules"
      label-width="80px"
    >
      <el-form-item label="公司名称：">
        <el-input v-model="companyName" disabled></el-input>
      </el-form-item>
      
      <el-form-item label="手机号：">
        <el-input v-model="mobile" disabled></el-input>
      </el-form-item>
      
      <el-form-item label="备注：" prop="note">
        <el-input
          v-model="form.note"
          type="textarea"
          placeholder="请输入备注信息"
          :rows="4"
          maxlength="200"
          show-word-limit
        ></el-input>
      </el-form-item>
    </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { addHyxUserNote } from '@/api/member'

export default {
  name: 'Note',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userId: {
      type: [String, Number],
      default: ''
    },
    currentNote: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      submitting: false,
      form: {
        note: this.currentNote || ''
      },
      rules: {
        note: [
          { required: true, message: '请输入备注信息', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    companyName() {
      return this.$parent.currentUser ? this.$parent.currentUser.company_name : ''
    },
    mobile() {
      return this.$parent.currentUser ? this.$parent.currentUser.mobile : ''
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.form.note = this.currentNote || ''
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    handleSubmit() {
      this.$refs.noteForm.validate(async valid => {
        if (!valid) return
        
        this.submitting = true
        try {
          // 调用添加备注API接口
          const params = {
            id: this.userId,
            note: this.form.note
          }
          
          const res = await addHyxUserNote(params)
          if (res.err_code === 0) {
            this.$message.success('备注保存成功')
            this.$emit('success', this.form.note)
            this.handleClose()
          } else {
            this.$message.error('保存备注失败: ' + res.err_msg)
          }
        } catch (error) {
          console.error('保存备注失败:', error)
          this.$message.error('保存备注失败: ' + error.message)
        } finally {
          this.submitting = false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-footer {
  text-align: center;
}
</style>